import iziToast from 'izitoast/dist/js/iziToast.min.js';

export default (function (w, d) {
    'use strict';

    function Message(message = '', type = '') {
        if (message !== undefined && type !== undefined) {
            switch (type) {
                case 'success':
                    iziToast.show({
                        message: message,
                        backgroundColor: '#fff',
                        position: 'bottomRight',
                        timeout: 5000,
                        progressBarColor: '#000',
                        overlayColor: 'rgba(0, 0, 0, 0)',
                        class: 'success-product'
                    });
                    break;
                case 'error':
                    iziToast.show({
                        message: message,
                        backgroundColor: '#fac4bc',
                        position: 'bottomRight',
                        timeout: 5000,
                        progressBarColor: '#ffeeeb',
                        overlayColor: 'rgba(0, 0, 0, 0)',
                        class: 'success-product'
                    });
                    break;
            }
        }
    }

    return Message;
}(window, document));

